<template lang="pug">
.robot-info.robot2s
  #info-b1
    .w
      .p1(:class="{fadeUp: isB1Visible}") 未来之选 尽显科技
      .p2.delay1(:class="{fadeUp: isB1Visible}") 维拉2.0 &nbsp;&nbsp;&nbsp;&nbsp; ¥18,999元/套
      .p3.delay1(:class="{fadeDown: isB1Visible}")
        img(src="../../../assets/web/2s-img1.png")
  #info-b2
    .w
      .p1(:class="{fadeUp: isB2Visible}") 语音技能
      .list
        .item(v-for="(item, index) in b2List", :class="[{fadeDown: isB2Visible}, 'delay' + (index+1)]")
          h3 {{item.text}}
          p {{item.tag}}
  #info-b3
    .w
      .p1(:class="{fadeUp: isB3Visible}") 亲情陪伴
      .p2.delay1.mt10(:class="{fadeUp: isB3Visible}")
        |免接听式视频通话
        br
        |即使不在家，随时查看家里任意角落
  #info-b4
    .w
      .p1(:class="{fadeUp: isB4Visible}") 智慧家庭
      .p2.delay1.mt10(:class="{fadeUp: isB4Visible}")
        |家庭新成员，从此多了一位生活助手。
        br(v-if="!isMobile")
        | 全天无休的“保安”，发现问题可以前往确认，出门在外亦可不必担忧。
      .p3.delay2(:class="{fadeDown: isB4Visible}")
        img(v-if="isMobile", src="../../../assets/mobile/2s-img2.png")
        img(v-else, src="../../../assets/web/2s-img2.png")
  #info-b5
    .w
      .p1(:class="{fadeUp: isB5Visible}") 智慧健康
      .p2.delay1.mt10(:class="{fadeUp: isB5Visible}")
        |多了一个关心你的机器“人”
        br
        |少了一个需要你担心的人
        br
        br
        |家人各项健康数据，机器人可以全部掌握，并汇总分析后给出建议。
      .p3.delay2.mt20(:class="{fadeDown: isB5Visible}")
        img(src="../../../assets/web/2s-img3.png")
  #info-b6
    .w
      .msg.blue.delay1(:class="{fadeUp: isB6Visible}") 主人，7点到了记得看新闻联播哦
      .msg2.delay2(:class="{fadeUp: isB6Visible}") 维拉，7点提醒我看新闻联播
      .p1.delay3(:class="{fadeUp: isB6Visible}") 智慧关爱
      .p3.delay4.mt10(:class="{fadeUp: isB6Visible}")
        |任何小事，随口交代，机器人自会帮你记着。
        br
        | 帮你语音提醒家人，关爱更进一步。
  #info-b7
    .w
      .p1(:class="{fadeUp: isB7Visible}") 运动自如
      .p3.delay1.mt10(:class="{fadeUp: isB7Visible}")
        |工业级TPU橡胶，子午线轮胎。
        br
        |粉末冶金工艺，行星轮减速器。
        br
        |摇杆式操作，享受控制机器人运动的快感。

</template>

<script>
import { isVisible } from '../../../common/utils'

export default {
  data () {
    return {
      isB1Visible: true,
      isB2Visible: false,
      isB3Visible: false,
      isB4Visible: false,
      isB5Visible: false,
      isB6Visible: false,
      isB7Visible: false,
      b2List: [
        { text: '“我要听周杰伦的歌”', tag: '音乐' },
        { text: '“学一下小狗的声音”', tag: '闲聊' },
        { text: '“设置一个明早8点的闹钟”', tag: '效率' },
        { text: '“海内存知己出自哪首诗”', tag: '百科' },
        { text: '“调高电视机音量”', tag: '智能家居' },
        { text: '“北京今天限行号是什么”', tag: '生活信息' },
        { text: '“妈妈昨晚睡眠情况如何”', tag: '家人健康' },
        { text: '“我要听故事”', tag: '有声资源' },
      ],
    }
  },
  computed: {},
  methods: {},
  created () {
    $(window).on('scroll', () => {
      this.isB1Visible = isVisible('#info-b1')
      this.isB2Visible = isVisible('#info-b2')
      this.isB3Visible = isVisible('#info-b3')
      this.isB4Visible = isVisible('#info-b4')
      this.isB5Visible = isVisible('#info-b5')
      this.isB6Visible = isVisible('#info-b6')
      this.isB7Visible = isVisible('#info-b7')
    })
  }
}
</script>

<style lang="stylus">
@import 'config'
.robot-info
  .w
    position relative
    .p1
      font-size 40px
      color #333
    .p2
      font-size 16px
      color #666
    .p3
      font-size 14px
      color #999
  &.robot2s
    #info-b1
      min-width 1200px
      height 748px
      background url('../../../assets/web/2s-info-b1.jpg') no-repeat center
      background-size auto 100%
      .w
        padding 200px 0 0 600px
      .p2
        font-size 24px
      .p3
        margin-top 70px
    #info-b2
      min-width 1200px
      background #f5f7f9
      .w
        text-align center
        padding 70px 0
      .list
        margin-top 80px
        .item
          display inline-block
          margin 0 20px 40px
          h3
            font-size 18px
            width 260px
            height 52px
            line-height 52px
            border-radius 30px 30px 5px
            background $blue
            color #fff
            margin-bottom 15px
          p
            color #999
    #info-b3
      min-width 1200px
      height 800px
      background url('../../../assets/web/2s-info-b3.jpg') no-repeat center
      background-size auto 100%
      .w
        padding 100px 0 0 10px
    #info-b4
      min-width 1200px
      height 800px
      background url('../../../assets/web/2s-info-b4.jpg') no-repeat center
      background-size auto 100%
      .w
        text-align center
        padding-top 100px
      .p2
        line-height 1.8
        margin-bottom 90px
    #info-b5
      min-width 1200px
      height 800px
      background url('../../../assets/web/2s-info-b5.jpg') no-repeat center
      background-size auto 100%
      overflow hidden
      .w
        text-align center
        padding-top 150px
    #info-b6
      min-width 1200px
      height 800px
      background url('../../../assets/web/2s-info-b6.jpg') no-repeat center
      background-size auto 100%
      .w
        position relative
        padding 650px 0 0 880px
      .msg
        position absolute
        top 600px
        left 80px
        text-align center
        font-size 16px
        width 260px
        height 52px
        line-height 52px
        border-radius 30px 30px 5px
        margin-bottom 15px
        background #fff
        color #333
        &.blue
          top 270px
          left 160px
          color #fff
          background $blue
      .msg2
        position absolute
        top 600px
        left 80px
        text-align center
        font-size 16px
        width 260px
        height 52px
        line-height 52px
        border-radius 30px 30px 30px 5px
        margin-bottom 15px
        background #fff
        color #333
    #info-b7
      min-width 1200px
      height 800px
      background url('../../../assets/web/2s-info-b7.jpg') no-repeat center
      background-size auto 100%
      .w
        text-align center
        padding-top 100px
      .p2
        line-height 1.2
        margin-bottom 90px
.is-mobile
  .robot2s
    #info-b1, #info-b2, #info-b3, #info-b4, #info-b5, #info-b6, #info-b7
      width 100%
      min-width inherit
      height r(1100)
    #info-b1
      background-image url('../../../assets/mobile/2s-info-b1.jpg')
      .w
        padding r(50) 0 0 0
        text-align center
        .p2
          font-size r(24)
        .p3
          font-size r(26)
          margin-top r(60)
          img
            width 80%
    #info-b2
      .w
        padding r(70) 0
        .list
          margin-top r(60)
          .item
            display block
            overflow hidden
            margin 0 auto r(58)
            h3
              float right
              height r(56)
              line-height r(56)
              font-size r(28)
              width r(400)
              margin-right r(100)
              margin-bottom 0
            p
              float left
              width r(200)
              height r(56)
              line-height r(56)
              text-align right

    #info-b3
      background-image url('../../../assets/mobile/2s-info-b3.jpg')
      .w
        padding r(100) 0 0 r(90)
    #info-b4
      background-image url('../../../assets/mobile/2s-info-b4.jpg')
      .w
        padding-top r(100)
        .p2
          margin-bottom r(90)
          padding 0 r(60)
        .p3
          img
            width 80%
    #info-b5
      background-image url('../../../assets/mobile/2s-info-b5.jpg')
      .w
        padding-top r(40)
        .p1, .p2, .p3
          color #fff
        img
          width 70%
          margin-top r(250)
    #info-b6
      background-image url('../../../assets/mobile/2s-info-b6.jpg')
      .w
        padding r(900) 0 0 r(40)
      .msg
        width r(400)
        height r(60)
        line-height r(60)
        font-size r(24)
        top r(690)
        left r(110)
        &.blue
          top r(500)
          left r(160)
      .msg2
        width r(400)
        height r(60)
        line-height r(60)
        font-size r(24)
        top r(690)
        left r(110)
        &.blue
          top r(96)
          left r(160)
    #info-b7
      background-image url('../../../assets/mobile/2s-info-b7.jpg')
      .w
        padding-top r(100)
  .robot-info
    .w
      .p1
        font-size r(46)
      .p2
        font-size r(24)
</style>



// WEBPACK FOOTER //
// src/views/robot/2s/info.vue